import { render } from "./AppliedFiltersTags.vue?vue&type=template&id=e80cf5c0&scoped=true"
import script from "./AppliedFiltersTags.vue?vue&type=script&lang=js"
export * from "./AppliedFiltersTags.vue?vue&type=script&lang=js"

import "./AppliedFiltersTags.vue?vue&type=style&index=0&id=e80cf5c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80cf5c0"]])

export default __exports__